import React from 'react';
import { SERVICE_TYPES, PRODUCT_IDS } from '@adsk/alloy-provider';
import { CollaborationIcon, FolderIcon, BoxesStackedIcon, RulerTriangleIcon, HammerIcon, MoneyIcon, ChartBarIcon, GearIcon } from '@adsk/alloy-react-icon';
export const PAGE_VARIANTS = {
  PROJECT: 'project',
  ACCOUNT: 'account'
};

/**
 * This const is used for account view only, since we use an old BIM360 endpoint.
 * Once we have an ACC compatible account entitlements endpoint, we could remove this const.
 * When adding new products for accounts, we need to update this list as well.
 */
export const PRODUCTS = [{
  id: PRODUCT_IDS.DOCS,
  serviceType: SERVICE_TYPES.DOC_MANAGER,
  renderIcon: p => /*#__PURE__*/React.createElement(FolderIcon, p),
  nameTranslationKey: 'DOCS'
}, {
  id: PRODUCT_IDS.DESIGN_COLLABORATION,
  serviceType: SERVICE_TYPES.COLLAB,
  nameTranslationKey: 'DESIGN_COLLABORATION',
  renderIcon: p => /*#__PURE__*/React.createElement(CollaborationIcon, p)
}, {
  id: PRODUCT_IDS.MODEL_COORDINATION,
  serviceType: SERVICE_TYPES.GNG,
  nameTranslationKey: 'MODEL_COORDINATION',
  renderIcon: p => /*#__PURE__*/React.createElement(BoxesStackedIcon, p)
}, {
  id: PRODUCT_IDS.QUANTIFY,
  serviceType: SERVICE_TYPES.QUANTIFICATION,
  nameTranslationKey: 'QUANTIFY',
  renderIcon: p => /*#__PURE__*/React.createElement(RulerTriangleIcon, p)
}, {
  id: PRODUCT_IDS.BUILD,
  serviceType: SERVICE_TYPES.PROJECT_HOME,
  renderIcon: p => /*#__PURE__*/React.createElement(HammerIcon, p),
  nameTranslationKey: 'BUILD'
}, {
  id: PRODUCT_IDS.COST,
  serviceType: SERVICE_TYPES.COST,
  renderIcon: p => /*#__PURE__*/React.createElement(MoneyIcon, p),
  nameTranslationKey: 'COST'
}, {
  id: PRODUCT_IDS.INSIGHT,
  serviceType: SERVICE_TYPES.INSIGHT,
  renderIcon: p => /*#__PURE__*/React.createElement(ChartBarIcon, p),
  nameTranslationKey: 'INSIGHT'
}, {
  id: PRODUCT_IDS.PROJECT_ADMINISTRATION,
  serviceType: SERVICE_TYPES.PROJECT_ADMIN,
  nameTranslationKey: 'PROJECT_ADMIN',
  renderIcon: p => /*#__PURE__*/React.createElement(GearIcon, p)
}, {
  id: PRODUCT_IDS.ACCOUNT_ADMINISTRATION,
  serviceType: SERVICE_TYPES.ACCOUNT_ADMIN,
  nameTranslationKey: 'ACCOUNT_ADMIN',
  renderIcon: p => /*#__PURE__*/React.createElement(GearIcon, p)
}];
export const ADMIN_PRODUCT_CATEGORY = 'admin';
export const POST_LICENSE_CONFIG = {
  revalidateOnFocus: false,
  shouldRetryOnError: false,
  revalidateOnMount: true
};
//# sourceMappingURL=consts.js.map